import React from "react";
import { Link } from "react-router-dom";

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 text-center p-6">
      <div className="max-w-3xl bg-white shadow-lg rounded-2xl p-8">
        {/* App Name & Branding */}
        <h1 className="text-4xl font-bold text-blue-600">Pinplus</h1>
        <p className="text-gray-600 mt-4">
          A smart way to manage your tasks and schedule efficiently.
        </p>

        {/* Description of App Functionality */}
        <div className="mt-6 text-left">
          <h2 className="text-2xl font-semibold text-gray-800">
            What is Pinplus?
          </h2>
          <p className="text-gray-600 mt-2">
            Pinplus helps users organize their daily tasks, set reminders, and
            collaborate with teams.
          </p>

          <h2 className="text-2xl font-semibold text-gray-800 mt-6">
            Why Do We Collect User Data?
          </h2>
          <p className="text-gray-600 mt-2">
            We collect minimal user data to provide a personalized experience.
            Your privacy is our priority.
          </p>
        </div>

        {/* Privacy Policy Link (Must match Google Consent Screen) */}
        <div className="mt-6">
          <Link
            to="/privacy-policy"
            className="text-blue-500 hover:underline text-lg"
          >
            Privacy Policy
          </Link>
        </div>

        {/* Contact Information */}
        <div className="mt-6">
          <h2 className="text-2xl font-semibold text-gray-800">Contact Us</h2>
          <p className="text-gray-600">Email: infopinplus@gmail.com</p>
        </div>

        <div className="mt-8">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} MyApp. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
}
